import { render, staticRenderFns } from "./BirthDayInput.vue?vue&type=template&id=9ee31a8c"
import script from "./BirthDayInput.vue?vue&type=script&lang=ts"
export * from "./BirthDayInput.vue?vue&type=script&lang=ts"
import style0 from "./BirthDayInput.vue?vue&type=style&index=0&id=9ee31a8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports